import * as React from 'react';
import { Link } from 'react-router-dom';

import { BashShellIcon } from '../assets/BashIcon';
import { BellIcon } from '../assets/BellIcon';
import { DatabaseIcon } from '../assets/DatabaseIcon';
import { DiscountIcon } from '../assets/DiscountIcon';
import { GitMerge } from '../assets/GitMerge';
import { HandGiftIcon } from '../assets/HandGiftIcon';
import { PPSCheckboxIcon } from '../assets/PPSCheckboxIcon';
import { RightArrow } from '../assets/RightArrow';
import { Search } from '../assets/Search';
import { User } from '../assets/User';
import { InfoIcon } from '../assets/infoIcon';
import { Page } from '../pages/types';

const homePageItems = [
  { page: Page.UserManagement, icon: <User className="w-6 h-6 mr-4" /> },
  { page: Page.CustomerLookup, icon: <Search className="w-6 h-6 mr-4" /> },
  { page: Page.LeadLookup, icon: <Search className="w-6 h-6 mr-4" /> },
  { page: Page.DiscountLookup, icon: <DiscountIcon className="w-6 h-6 mr-4" /> },
  { page: Page.DiscountsPage, icon: <DiscountIcon className="w-6 h-6 mr-4" /> },
  {
    page: Page.ManagePPSSurvey,
    icon: <PPSCheckboxIcon className="w-6 h-6 mr-4" />,
  },
  { page: Page.ManageDataPage, icon: <DatabaseIcon className="w-6 h-6 mr-4" /> },
  { page: Page.PromotionsPage, icon: <HandGiftIcon className="w-6 h-6 mr-4" /> },
  { page: Page.ProductPricingNutrientInfo, icon: <InfoIcon className="w-6 h-6 mr-4" /> },
  { page: Page.FetchAiPage, icon: <GitMerge className="w-6 h-6 mr-4" /> },
  { page: Page.OnCallDashboard, icon: <BellIcon className="w-6 h-6 mr-4" /> },
  { page: Page.CommandRunner, icon: <BashShellIcon className="w-6 h-6 mr-4" /> },
];

interface ComponentBoxProps {
  title: string;
  page: Page;
}

export const ComponentBox = ({ title, page }: ComponentBoxProps) => {
  if (!homePageItems.some((item) => item.page === page)) {
    return <>This page is not supported!</>;
  }

  return (
    <Link to={page}>
      <div className="m-1 p-5 w-[390px] h-15 rounded-sm shadow-md cursor-pointer bg-secondary border flex items-center">
        {homePageItems.find((item) => item.page === page)?.icon}
        <h2 className="text-xl font-semibold">{title}</h2>
        <RightArrow className="ml-auto w-6 h-6" />
      </div>
    </Link>
  );
};
